export const REPORT_CONSULT_STATS_REQUESTED = 'REPORT_CONSULT_STATS_REQUESTED';
export const REPORT_CONSULT_STATS_SUCCEED = 'REPORT_CONSULT_STATS_SUCCEED';
export const REPORT_CONSULT_STATS_FAILED = 'REPORT_CONSULT_STATS_FAILED';

export const REPORT_CONSULT_DAY_STATS_REQUESTED = 'REPORT_CONSULT_DAY_STATS_REQUESTED';
export const REPORT_CONSULT_DAY_STATS_SUCCEED = 'REPORT_CONSULT_DAY_STATS_SUCCEED';
export const REPORT_CONSULT_DAY_STATS_FAILED = 'REPORT_CONSULT_DAY_STATS_FAILED';
